import { render } from "./PrizesCards.vue?vue&type=template&id=66ab4ce2&scoped=true"
import script from "./PrizesCards.vue?vue&type=script&lang=js"
export * from "./PrizesCards.vue?vue&type=script&lang=js"

import "./PrizesCards.vue?vue&type=style&index=0&id=66ab4ce2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ab4ce2"]])

export default __exports__